import { render, staticRenderFns } from "./CartaoAniversario.vue?vue&type=template&id=3864dbb0&scoped=true&"
import script from "./CartaoAniversario.vue?vue&type=script&lang=js&"
export * from "./CartaoAniversario.vue?vue&type=script&lang=js&"
import style0 from "./CartaoAniversario.vue?vue&type=style&index=0&id=3864dbb0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3864dbb0",
  null
  
)

export default component.exports